import { useEffect } from "react";
import PropTypes from "prop-types";

import TemplateGroupPresenter from "presenters/TemplateGroupPresenter";
import Placeholder from "components/Placeholder";
import selectedCastNumber from "utils/selectedCastNumber";

import MultiCast from "./components/MultiCast";
import SingleCast from "./components/SingleCast";

const CastNumberSelect = ({ templateGroup, label = "Cast by", size = "medium", fullWidth = false }) => {
  const hidden = TemplateGroupPresenter.isStraightUp(templateGroup);
  const isMulti = TemplateGroupPresenter.isMultiTemplate(templateGroup);
  const firstCastNum = TemplateGroupPresenter.firstCastNum(templateGroup);
  const sizing = size === "small" ? { m: 1, minWidth: 110 } : {};

  useEffect(() => {
    selectedCastNumber.clear();
  }, []);

  if (isMulti)
    return <MultiCast templateGroup={templateGroup} label={label} sizing={sizing} size={size} fullWidth={fullWidth} />;
  if (firstCastNum) return <SingleCast templateGroup={templateGroup} />;
  if (hidden) return null;

  return <Placeholder variant="text" />;
};

CastNumberSelect.propTypes = {
  templateGroup: TemplateGroupPresenter.shape(),
  label: PropTypes.string,
  size: PropTypes.string,
  fullWidth: PropTypes.bool,
};

export default CastNumberSelect;
